import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";

class AdminService {
  getServerList() {
    return axiosInstance.post("get-server", {}, { headers: authHeader() });
  }

  changePassword(data) {
    return axiosInstance.post("change-password", data, {
      headers: authHeader(),
    });
  }

  async checkDnsActivation() {
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    const ipData = await ipResponse.json();
    const publicIp = ipData.ip;
    return axiosInstance.post(
      "check-dns-activation",
      { client_public_ip: publicIp },
      { headers: authHeader() }
    );
  }

  dnsNetworkPoolBind(data) {
    return axiosInstance.post("dns-subscriber-network-pool-bind", data, {
      headers: authHeader(),
    });
  }

  getCurrentUser() {
    return axiosInstance.post(
      "get-user",
      {},
      {
        headers: authHeader(),
      }
    );
  }
}

export default new AdminService();
